import styled from 'styled-components';

const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.clearGray};
    background: ${(props) => props.theme.colors.primaryWhite};
    font-family: ${(props) => props.theme.fonts.family.inter};
    height: 48px;
    width: 100%;
`;

const InputField = styled.input`
    width: 100%;
    height: 40px;
    border: none;
    outline: none;
    font-size: 0.875rem;

    background: ${(props) => props.theme.colors.primaryWhite};
    ${(props) => props.theme.fonts.variant.regular()};
    
    ::placeholder {
        color: ${(props) => props.theme.colors.clearGray};
    }
`;

export {
  InputWrapper,
  InputField
};
